// This file is automatically generated. Do not edit manually.

import { PartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/partConfiguratorType";
import { ConfiguratorTestEnvironmentParams } from "src/api/generated/erp/configurator/testEnvironment/configuratorTestEnvironmentParams";
import { CustomerPriceGroup } from "src/api/generated/erp/db/types/tables/customerPriceGroup";
import { CatalogPartRevision } from "src/api/generated/erp/db/types/tables/catalogPartRevision";
import { SalesPartView } from "src/api/generated/erp/db/types/tables/salesPartView";
import { ConfiguratorLibraryVersion } from "src/api/generated/erp/db/types/tables/configuratorLibraryVersion";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace TestConfigurationContextDataFormApi {
	export async function getInitData(args: {
		configuratorType: PartConfiguratorType;
	}): Promise<TestConfigurationContextDataFormApi_InitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/testing/testContextDataForm/getInitData",
			method: "POST",
			data: {
				configuratorType: args.configuratorType,
			},
		});
		return response as TestConfigurationContextDataFormApi_InitData;
	}

	export async function saveTestConfigurationContextData(args: {
		configuratorType: PartConfiguratorType;
		contextData: ConfiguratorTestEnvironmentParams;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/testing/testContextDataForm/saveTestConfigurationContextData",
			method: "POST",
			data: {
				configuratorType: args.configuratorType,
				contextData: args.contextData,
			},
		});
		return response as void;
	}
}

export interface TestConfigurationContextDataFormApi_InitData {
	activeRootRevisionId: number | null | undefined;
	configurableBomLines: Array<TestConfigurationContextDataFormApi_InitData_ConfigurableBomLine>;
	contextData: ConfiguratorTestEnvironmentParams;
	customerPriceGroupOptions: Array<CustomerPriceGroup>;
	libraries: Array<TestConfigurationContextDataFormApi_InitData_ConfiguratorLibraryDto>;
	realObjectTestConfigurator: boolean;
	rootRevisionOptions: Array<CatalogPartRevision>;
	salesPartOptions: Array<SalesPartView>;
}

export interface TestConfigurationContextDataFormApi_InitData_ConfigurableBomLine {
	activeRevisionId: number | null | undefined;
	catalogPartId: number;
	partDescription1: string;
	partDescription2: string;
	partNo: string;
	revisionOptions: Array<CatalogPartRevision>;
}

export interface TestConfigurationContextDataFormApi_InitData_ConfiguratorLibraryDto {
	versionOptions: Array<ConfiguratorLibraryVersion>;
	configuratorLibraryId: number;
	name: string;
}
